import { Add, CloseRounded } from '@mui/icons-material';
import {
    Box,
    Button,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Typography
} from "@mui/material";
import { useRef, useState } from 'react';
import { getSingleFileByNameFromAWSS3Bucket, uploadFileToAWSS3Bucket } from '../../../services/uploadFileOnAWS_S3_Bucket';
import { GameCssStyles } from '../GameCssStyles';
import EntertainmentEntityDialog from './EntertainmentEntityDialog';
import ReorderDialogWithDropDown from './ReorderDialogWithDropDown';

const defaultQuestion = {
    questionText: "",
    status: "",
    multimedia: {
        mediaType: "",
        url: "",
        aspectRatio: ""
    },
    options: [
        // {
        //     id: "",
        //     text: "",
        //     label: "",
        //     entertainmentEntityId: "",
        //     multimedia: {
        //         mediaType: "",
        //         url: "",
        //         aspectRatio: ""
        //     },
        // }
    ],
    fantasyResult: {
        data: [

        ]
    }
};

const defaultFantasyAnswerData = {
    "optionId": "",
    "entertainmentEntityId": "",
    "rank": 1
}

const defaultFantasyAnswer = {
    //resultDate: "",
    data: defaultFantasyAnswerData
}

const SpinTheWheelQuestionEditor = ({ formGameData, setFormGameData, handleChange }) => {

    const [isOpenEntertainmentEntityDialog, setIsOpenEntertainmentEntityDialog] = useState(false);
    const [reoderOpenDialog, setReorderOpenDialog] = useState(false);
    const questionFileInputRef = useRef(null);
    const answerFileInputRefs = useRef([]);
    const question = formGameData?.question ?? null;
    const options = question?.options ?? [];
    //const [options, setOptions] = useState([]);

    //console.log("question : ", question);

    const handleFileUpload = async (e, pathPrefix) => {
        const file = e.target.files[0];
        //console.log("file : ", file);

        if (file) {
            const url = URL.createObjectURL(file);
            //console.log("url : ", url);
            let mediaType = '';
            if (file.type.startsWith('image/')) mediaType = 'image';
            else if (file.type.startsWith('video/')) mediaType = 'video';
            else if (file.type.startsWith('audio/')) mediaType = 'audio';

            if (pathPrefix === 'question') {
                console.log("pathPrefix : question",)
                const result = await uploadFileToAWSS3Bucket("questions", file);
                console.log("Upload AWS result : ", result)
                const fileResult = await getSingleFileByNameFromAWSS3Bucket("questions", result?.key?.split('/').pop());
                console.log("Single File AWS fileResult : ", fileResult?.url?.href)
                handleChange(`${pathPrefix}.multimedia.url`, fileResult?.url?.href);
            }
            else {
                console.log("pathPrefix : options",)
                const result = await uploadFileToAWSS3Bucket("options", file);
                console.log("Upload AWS result : ", result)
                const fileResult = await getSingleFileByNameFromAWSS3Bucket("options", result?.key?.split('/').pop());
                console.log("Single File AWS fileResult : ", fileResult?.url?.href)
                handleChange(`${pathPrefix}.multimedia.url`, fileResult?.url?.href);
            }
            //console.log("pathPrefix : ", pathPrefix)
            //console.log(`${pathPrefix}.multimedia.url`, url)
            handleChange(`${pathPrefix}.multimedia.mediaType`, mediaType);
        }
    };

    const createQuestion = () => {
        //console.log("Creating new question", JSON.parse(JSON.stringify(defaultQuestion)));
        handleChange('question', JSON.parse(JSON.stringify(defaultQuestion)));
    }

    const addFantasyResult = () => {
        const defaultAnswer = JSON.parse(JSON.stringify(defaultFantasyAnswer));
        //console.log("fantasyResult : ", question?.fantasyResult);
        if (question?.fantasyResult?.data) {
            //console.log("addFantasyResult 1")
            handleChange('question.fantasyResult.data', [defaultFantasyAnswerData]);
        } else {
            console.log("addFantasyResult 2")
            const updatedQuestion = {
                ...formGameData?.question,
                fantasyResult: {
                    data: [defaultFantasyAnswerData]
                }
            };
            handleChange('question', updatedQuestion);
        }
    }

    const addFantasyRankAndAnswer = () => {
        const updated = [...question?.fantasyResult?.data];

        updated.push({
            rank: question?.fantasyResult?.data.length + 1,
            optionId: '',
            entertainmentEntityId: '',
        });

        setFormGameData(prev => ({
            ...prev,
            question: {
                ...prev.question,
                fantasyResult: {
                    ...prev.question.fantasyResult,
                    data: updated
                }
            }
        }));
    }

    const removefantasyResultItem = (idx) => {
        const updated = [...(question?.fantasyResult?.data || [])];
        updated.splice(idx, 1);

        setFormGameData(prev => ({
            ...prev,
            question: {
                ...prev.question,
                fantasyResult: {
                    ...prev.question.fantasyResult,
                    data: updated
                }
            }
        }));
    };

    const numberOptions = Array.from({ length: 12 }, (_, i) => (i + 1).toString());
    const multiplierOptions = Array.from({ length: 5 }, (_, i) => ((i + 3) * 0.5).toFixed(1) + 'x');

    return (
        <>
            <Box sx={GameCssStyles.containerStyleColumn_sx}>
                {/* <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>Game Contest Question & Answers</Typography> */}

                <Box sx={{ ...GameCssStyles.containerStyleColumnWithoutBorder_sx, width: '100%', mt: 2, justifyContent: 'start', alignItems: 'start' }}>
                    <Typography fontWeight={600} mb={1}>Entertainment Entities For Spin Wheel</Typography>
                    {question?.options && <Box container spacing={2} sx={{ width: '100%' }}>
                        {options?.map((option, idx) => (
                            <Box
                                sx={{
                                    position: 'relative',
                                    height: 140,
                                    width: '100%',
                                    borderRadius: 2,
                                    overflow: 'hidden',
                                    //backgroundImage: `url(${item.multimedia.url})`,
                                    backgroundColor: 'whitesmoke',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                    padding: 1,
                                    m: 1,
                                    border: '1px solid #ccc',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                                onClick={() => {
                                    // if (item?.multimedia) {
                                    //   setSelectedEntertainmentEntity(item);
                                    //   //setOpenMediaDialog(true);
                                    // }
                                }}
                                key={option.id}
                            >
                                {/* Image thumbnail */}
                                <Box
                                    sx={{
                                        flexGrow: 0,
                                        width: 80,
                                        height: 80,
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        backgroundImage: `url(${option?.multimedia?.[0]?.url})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        mr: 2,
                                        flexShrink: 0,
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                    onClick={() => {
                                        // if (item?.multimedia) {
                                        //   setSelectedEntertainmentEntity(item);
                                        //   //setOpenMediaDialog(true);
                                        // }
                                    }}
                                />

                                {/* Info area */}
                                <Box sx={{ flexGrow: 0, width: '20%' }}>
                                    <Typography fontWeight="bold" sx={{ fontSize: 12 }}>
                                        {option.displayName}
                                    </Typography>
                                    <Typography variant="body2" noWrap>
                                        {option.genres?.join(', ') || 'N/A'}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {option?.type}
                                    </Typography>
                                </Box>

                                <Box sx={{ ...GameCssStyles.containerStyleRowWithoutBorder_sx, flexGrow: 1, ml: 5 }}>
                                    <FormControl fullWidth size="normal" sx={{}}>
                                        <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Index on Wheel</InputLabel>
                                        <Select
                                            value={option.index || (idx + 1) || ''}
                                            onChange={(e) => {
                                                handleChange(`question.options.${idx}.index`, e.target.value);
                                            }}
                                            label="Index on Wheel"
                                            readOnly={true}
                                            sx={GameCssStyles.formFiledStyle_sx2}
                                        >
                                            {/* <MenuItem value="N/A">N/A</MenuItem> */}
                                            {numberOptions.map((item, idx) => {
                                                return (<MenuItem
                                                    key={idx}
                                                    value={item}
                                                    sx={GameCssStyles.menuItemStyle_sx}>
                                                    {item}
                                                </MenuItem>)
                                            })}
                                        </Select>
                                    </FormControl>

                                    <FormControl fullWidth size="normal" sx={{}}>
                                        <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Weight of Entity</InputLabel>
                                        <Select
                                            value={option.weight || ''}
                                            onChange={(e) => {
                                                handleChange(`question.options.${idx}.weight`, e.target.value);
                                            }}
                                            label="Weight of Entity"
                                            sx={GameCssStyles.formFiledStyle_sx2}
                                        >
                                            {/* <MenuItem value="N/A">N/A</MenuItem> */}
                                            {multiplierOptions.map((item, idx) => {
                                                return (<MenuItem
                                                    key={idx}
                                                    value={item}
                                                    sx={GameCssStyles.menuItemStyle_sx}>
                                                    {item}
                                                </MenuItem>)
                                            })}
                                        </Select>
                                    </FormControl>
                                </Box>

                                {/* Top-right controls */}
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 4,
                                        right: 4,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 0.5,
                                    }}
                                >
                                    <IconButton
                                        onClick={() => {
                                            //setOptions(prev => prev.filter(item => item?.id !== option?.id));
                                            const updatedOptions = options?.filter(item => item?._id !== option?._id);
                                            console.log("option : ", option)
                                            console.log("options : ", options)
                                            console.log("updatedOptions : ", updatedOptions)
                                            handleChange(`question.options`, updatedOptions);
                                        }}
                                        size="small"
                                        sx={{ p: 0.5 }}
                                    >
                                        <CloseRounded fontSize="small" />
                                    </IconButton>
                                </Box>

                            </Box>

                            // <Box sx={{ ...GameCssStyles.containerStyleRow_sx, width: '100%' }} key={idx}>

                            //     <Box sx={{ ...GameCssStyles.containerStyleColumnWithoutBorderNoColor_sx, width: '100%' }}>

                            //         {/* 

                            //          <TextField
                            //             label="Answer Text"
                            //             value={option?.text || ''}
                            //             onChange={(e) => handleChange(`question.options.${idx}.text`, e.target.value)}
                            //             fullWidth
                            //             multiline
                            //             rows={3}
                            //             sx={GameCssStyles.formMultiLineTextField_sx}
                            //         />

                            //         <Box sx={{ ...GameCssStyles.containerStyleColumnWithoutBorderNoColor_sx, width: '100%' }}>

                            //             <Box sx={{ ...GameCssStyles.containerStyleRowWithoutBorderNoColor_sx, width: '100%' }}>

                            //                 <TextField
                            //                     label="Label"
                            //                     value={option?.label || ''}
                            //                     onChange={(e) => handleChange(`question.options.${idx}.label`, e.target.value)}
                            //                     width="100px"
                            //                     sx={GameCssStyles.formSingleLineTextField_sx}
                            //                 />

                            //                 <TextField
                            //                     label="Multimedia URL"
                            //                     value={option?.multimedia?.url || ''}
                            //                     onChange={(e) => {
                            //                         const mediaType = getMediaTypeFromUrl(e.target.value);
                            //                         handleChange(`question.options.${idx}.multimedia.mediaType`, mediaType);
                            //                         handleChange(`question.options.${idx}.multimedia.url`, e.target.value)
                            //                     }}
                            //                     fullWidth
                            //                     sx={GameCssStyles.formSingleLineTextField_sx}
                            //                 />

                            //                 <Button variant="contained" onClick={() => answerFileInputRefs.current[idx].click()}>Upload</Button>
                            //                 <input
                            //                     type="file"
                            //                     hidden
                            //                     ref={(el) => (answerFileInputRefs.current[idx] = el)}
                            //                     onChange={(e) => handleFileUpload(e, `question.options.${idx}`)}
                            //                     accept="image/*,video/*,audio/*"
                            //                 />
                            //             </Box>

                            //             <Box sx={{ ...GameCssStyles.containerStyleRowWithoutBorderNoColor_sx, width: '100%', gap: 10, justifyContent: 'end', alignItems: 'center' }}>

                            //                 <Button variant="contained" sx={{ backgroundColor: 'red', color: 'white' }} onClick={() => removeAnswer(idx)}>Remove</Button>

                            //             </Box>

                            //         </Box> */}

                            //     </Box>

                            // </Box>
                        ))}
                    </Box>}

                    <Box mt={2}>
                        <Button startIcon={<Add />} variant="contained" onClick={() => {
                            //addAnswer
                            setIsOpenEntertainmentEntityDialog(true);
                        }}>
                            Add Entertainment Entity
                        </Button>
                    </Box>
                </Box>
            </Box>

            <EntertainmentEntityDialog
                open={isOpenEntertainmentEntityDialog}
                onClose={() => {
                    setIsOpenEntertainmentEntityDialog(false)
                }}
                onSubmit={(selectedItems, entertainment_entity_data) => {
                    //console.log("selectedItems : ", selectedItems);
                    //setOptions(selectedItems);
                    const updatedData = selectedItems?.map(item => ({
                        ...item,
                        multimedia: item.multimedia?.length > 0 ? [item.multimedia[0]] : []
                    }));

                    handleChange(`question.options`, updatedData);
                }}
                selectedItems={options}
                fullScreen
            />

            <ReorderDialogWithDropDown
                open={reoderOpenDialog}
                onClose={() => setReorderOpenDialog(false)}
                data={options}
                onSave={(newOrder) => {
                    // const answerResult = newOrder.map((item) => ({
                    //     rank: item?.rank, // default value
                    //     optionId: `${item?._id}`,
                    //     entertainmentEntityId: `${item?.entertainmentEntityId ? item?.entertainmentEntityId : '1234'}`
                    // }))
                    console.log("answerResult : ", newOrder)
                    handleChange(`question.fantasyResult.data`, newOrder);
                    //setOrderedData(newOrder)
                }}
            />
        </>
    )
}

export default SpinTheWheelQuestionEditor
